import "./WhyChooseSection.css";

const CheckIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M5 13l4 4L19 7"
			stroke="currentColor"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const BENEFITS = [
	"Original licensed wellness music",
	"Designed for spas, hotels & retreats",
	"Easy plug-and-play setup",
	"Multiple music zones per property",
	"Over 30 wellness music genres",
	"Daily scheduling with the Planner",
	"Professional 432 Hz audio production",
	"Secure and reliable streaming",
	"Dedicated technical support",
];

const WhyChooseSection = () => (
	<section className="why-section">
		<div className="why-intro">
			<span className="why-eyebrow">Why BodhiStreams</span>
			<h2 className="why-heading">
				Everything you need for a calmer, more memorable guest experience.
			</h2>
			<p className="why-lead">
				Transform every guest interaction into a more relaxing, immersive
				wellness moment — through the power of carefully crafted music.
			</p>
		</div>

		<ul className="why-list">
			{BENEFITS.map((benefit) => (
				<li key={benefit} className="why-item">
					<span className="why-item-icon">
						<CheckIcon />
					</span>
					<span className="why-item-text">{benefit}</span>
				</li>
			))}
		</ul>
	</section>
);

export default WhyChooseSection;
